import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'
import Tab from './src/tab'
import TabPane from './src/tab-pane.vue'

export const SgTab = withInstall(Tab, {
  TabPane,
})
export default SgTab
export const SgTabPane = withNoopInstall(TabPane)

export * from './src/tab'
export * from './src/tab-bar'
export * from './src/tab-nav'
export * from './src/tab-pane'
export * from './src/constants'
